export const SELFIE = 'user';
export const ASSISTED = 'environment';